export default __webpack_public_path__ + "static/bg-crop-7ab6bf64439281c25ba0dba865662b24.mp4";